import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';

import { DsLoadingSpinner } from '@frontend/ui/loading-spinner';

import { LoginContentService } from '../login-content.service';
import { LoginSpinnerService } from './login-spinner.service';

/**
 * @stable
 */
@Component({
    imports: [DsLoadingSpinner],
    selector: 'vn-login-spinner',
    templateUrl: 'login-spinner.html',
    styleUrls: ['../../../../../../themepark/themes/whitelabel/components/login-spinner/styles.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginSpinnerComponent {
    loginContentService = inject(LoginContentService);
    loginSpinnerService = inject(LoginSpinnerService);
}
